import axios from 'axios';
import { authService } from './auth';
import { getApiUrl } from './apiBase';

const API_URL = getApiUrl();

// Mock data for development when server is not available
const MOCK_FURNITURE: FurnitureData[] = [
  {
    _id: '1',
    title: 'Modern Gray Sofa',
    description: 'Comfortable modern sofa in excellent condition. Perfect for apartments and small living rooms.',
    category: 'sofa',
    condition: 'good',
    price: 599,
    neighborhood: 'allston',
    images: ['https://images.unsplash.com/photo-1555041469-a586c61ea9bc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80'],
    location: {
      address: '123 Main St',
      city: 'Boston',
      state: 'MA',
      zipCode: '02115'
    },
    deliveryAvailable: true,
    deliveryFee: 50
  },
  {
    _id: '2',
    title: 'Wooden Dining Table',
    description: 'Solid wood dining table that seats 6 people. Minor scratches but in good condition overall.',
    category: 'table',
    condition: 'good',
    price: 350,
    images: ['https://images.unsplash.com/photo-1533090161767-e6ffed986c88?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1769&q=80'],
    location: {
      address: '456 Park Ave',
      city: 'Cambridge',
      state: 'MA',
      zipCode: '02139'
    },
    deliveryAvailable: false
  },
  {
    _id: '3',
    title: 'Vintage Armchair',
    description: 'Comfortable vintage armchair with wooden frame. Recently reupholstered.',
    category: 'chair',
    condition: 'like-new',
    price: 250,
    images: ['https://images.unsplash.com/photo-1581539250439-c96689b516dd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1765&q=80'],
    location: {
      address: '789 Harvard St',
      city: 'Boston',
      state: 'MA',
      zipCode: '02115'
    },
    deliveryAvailable: true,
    deliveryFee: 30
  },
  {
    _id: '4',
    title: 'Modern Coffee Table',
    description: 'Beautiful coffee table with glass top and wooden legs. Perfect for any modern living room.',
    category: 'table',
    condition: 'good',
    price: 180,
    images: ['https://images.unsplash.com/photo-1577208288347-b24488f3fb9d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80'],
    location: {
      address: '101 Newbury St',
      city: 'Boston',
      state: 'MA',
      zipCode: '02116'
    },
    deliveryAvailable: true,
    deliveryFee: 25
  },
  {
    _id: '5',
    title: 'Queen Size Bed Frame',
    description: 'Queen size bed frame with headboard. Barely used and in like-new condition.',
    category: 'bed',
    condition: 'like-new',
    price: 420,
    images: ['https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80'],
    location: {
      address: '222 Commonwealth Ave',
      city: 'Boston',
      state: 'MA',
      zipCode: '02116'
    },
    deliveryAvailable: true,
    deliveryFee: 60
  },
  {
    _id: '6',
    title: 'Bookshelf',
    description: 'Tall bookshelf with 5 shelves. Great for organizing books and display items.',
    category: 'storage',
    condition: 'good',
    price: 120,
    images: ['https://images.unsplash.com/photo-1594620302200-9a762244a156?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1769&q=80'],
    location: {
      address: '333 Beacon St',
      city: 'Boston',
      state: 'MA',
      zipCode: '02116'
    },
    deliveryAvailable: false
  },
  {
    _id: '7',
    title: 'Side Table with Storage',
    description: 'Compact side table with drawer, perfect for small spaces and bedrooms.',
    category: 'table',
    condition: 'good',
    price: 95,
    images: ['https://images.unsplash.com/photo-1499933374294-4584851497cc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1035&q=80'],
    location: {
      address: '444 Mass Ave',
      city: 'Boston',
      state: 'MA',
      zipCode: '02118'
    },
    deliveryAvailable: true,
    deliveryFee: 20
  },
  {
    _id: '8',
    title: 'Computer Desk',
    description: 'Spacious computer desk with keyboard tray. Ideal for home office setup.',
    category: 'desk',
    condition: 'good',
    price: 150,
    images: ['https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1035&q=80'],
    location: {
      address: '555 Tremont St',
      city: 'Boston',
      state: 'MA',
      zipCode: '02118'
    },
    deliveryAvailable: true,
    deliveryFee: 35
  },
  {
    _id: '9',
    title: 'Modern Pendant Light',
    description: 'Elegant pendant light with adjustable height. Perfect for dining areas or kitchen islands.',
    category: 'lighting',
    condition: 'like-new',
    price: 85,
    images: ['https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80'],
    location: {
      address: '678 Boylston St',
      city: 'Boston',
      state: 'MA',
      zipCode: '02116'
    },
    deliveryAvailable: true,
    deliveryFee: 15
  },
  {
    _id: '10',
    title: 'Sectional Sofa with Chaise',
    description: 'Large L-shaped sectional sofa with chaise lounge. Perfect for family rooms and entertaining.',
    category: 'sofa',
    condition: 'good',
    price: 750,
    images: ['https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80'],
    location: {
      address: '789 Columbus Ave',
      city: 'Boston',
      state: 'MA',
      zipCode: '02120'
    },
    deliveryAvailable: true,
    deliveryFee: 75
  },
  {
    _id: '11',
    title: 'Dining Chairs (Set of 4)',
    description: 'Set of 4 matching dining chairs with comfortable cushions. Solid wood construction.',
    category: 'chair',
    condition: 'good',
    price: 200,
    images: ['https://images.unsplash.com/photo-1551298370-9d3d53740c72?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80'],
    location: {
      address: '321 Huntington Ave',
      city: 'Boston',
      state: 'MA',
      zipCode: '02115'
    },
    deliveryAvailable: true,
    deliveryFee: 40
  },
  {
    _id: '12',
    title: 'Floor Lamp with Reading Light',
    description: 'Modern floor lamp with adjustable reading light. Perfect for living rooms or bedrooms.',
    category: 'lighting',
    condition: 'good',
    price: 65,
    images: ['https://images.unsplash.com/photo-1507473885765-e6ed057f782c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80'],
    location: {
      address: '987 Commonwealth Ave',
      city: 'Boston',
      state: 'MA',
      zipCode: '02215'
    },
    deliveryAvailable: true,
    deliveryFee: 20
  }
];

export const FURNITURE_CATEGORIES = [
  'sofa',
  'table',
  'chair',
  'desk',
  'bed',
  'dresser',
  'storage',
  'lighting',
  'other',
] as const;

export const FURNITURE_CONDITIONS = [
  'like-new',
  'good',
  'fair',
  'needs-repair',
] as const;

export type FurnitureCategory = (typeof FURNITURE_CATEGORIES)[number];
export type FurnitureCondition = (typeof FURNITURE_CONDITIONS)[number];

export interface FurnitureData {
  _id: string;
  title: string;
  description: string;
  category: string;
  condition: FurnitureCondition;
  price: number;
  minPrice?: number;
  originalPrice?: number;
  images: string[];
  location: {
    address?: string;
    city: string;
    state: string;
    zipCode?: string;
  };
  status?: 'available' | 'pending' | 'sold' | 'removed' | 'removed_by_admin';
  moderation?: { reason?: string };
  seller?: {
    _id: string;
    firstName?: string;
    lastName?: string;
    wechatId?: string;
    eduVerified?: boolean;
    school?: string;
  } | string;
  createdAt?: string;
  dimensions?: {
    width: number;
    height: number;
    depth: number;
    unit: 'in' | 'cm';
  };
  weight?: {
    value: number;
    unit: 'lbs' | 'kg';
  };
  brand?: string;
  material?: string[];
  color?: string[];
  pickupDetails?: string;
  neighborhood?: string;
  deliveryAvailable?: boolean;
  deliveryFee?: number;
  sellerId?: string; // Track which seller owns this item
}

// Payload for creating a listing — the server assigns _id, seller, status
export type NewFurnitureData = Omit<FurnitureData, '_id' | 'seller' | 'status' | 'createdAt'>;

export interface FurnitureFilters {
  page?: number;
  limit?: number;
  category?: string;
  condition?: string;
  minPrice?: number;
  maxPrice?: number;
  city?: string;
  state?: string;
  status?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  search?: string;
  neighborhood?: string;
}

class FurnitureService {
  private sellerListings: FurnitureData[] = []; // Store seller's listings separately in mock mode
  private readonly SELLER_LISTINGS_KEY = 'seller-listings';
  
  private getAuthHeader() {
    const token = authService.getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  private useMockData = false; // Real backend enabled (LAUNCH.md Phase 1)

  constructor() {
    // Load seller listings from localStorage
    this.loadSellerListings();
  }

  private loadSellerListings() {
    try {
      const stored = localStorage.getItem(this.SELLER_LISTINGS_KEY);
      if (stored) {
        this.sellerListings = JSON.parse(stored);
        console.log('Loaded seller listings from localStorage:', this.sellerListings.length, 'items');
      } else {
        console.log('No seller listings found in localStorage');
        this.sellerListings = [];
      }
    } catch (error) {
      console.error('Error loading seller listings from localStorage:', error);
      this.sellerListings = [];
    }
  }

  private saveSellerListings() {
    try {
      localStorage.setItem(this.SELLER_LISTINGS_KEY, JSON.stringify(this.sellerListings));
    } catch (error) {
      console.error('Error saving seller listings to localStorage:', error);
    }
  }

  private filterMockData(filters: FurnitureFilters): { furniture: FurnitureData[], totalPages: number } {
    let filteredData = [...MOCK_FURNITURE];
    
    // Apply search filter
    if (filters.search) {
      const searchLower = filters.search.toLowerCase();
      
      // 特殊处理"table"关键词，只匹配标题和类别
      if (searchLower === 'table') {
        filteredData = filteredData.filter(item => 
          item.title.toLowerCase().includes(searchLower) || 
          item.category.toLowerCase() === 'table'
        );
      } 
      // 特殊处理"desk"关键词，只匹配标题和类别
      else if (searchLower === 'desk') {
        filteredData = filteredData.filter(item => 
          item.title.toLowerCase().includes(searchLower) || 
          item.category.toLowerCase() === 'desk'
        );
      }
      // 处理更一般的搜索情况
      else {
        filteredData = filteredData.filter(item => {
          // 检查标题或类别是否匹配
          const titleMatch = item.title.toLowerCase().includes(searchLower);
          const categoryMatch = item.category.toLowerCase().includes(searchLower);
          
          // 如果关键词在标题或类别中，直接匹配
          if (titleMatch || categoryMatch) {
            return true;
          }
          
          // 检查描述，但避免不相关家具因描述中的字词匹配而显示
          // 例如，只有当搜索词不是"table"或"desk"等家具类型时，才搜索描述
          const commonFurnitureTypes = ['table', 'chair', 'sofa', 'bed', 'desk', 'shelf', 'cabinet'];
          const isSearchingFurnitureType = commonFurnitureTypes.some(type => 
            searchLower.includes(type)
          );
          
          // 如果不是搜索特定家具类型，则可以匹配描述
          if (!isSearchingFurnitureType) {
            return item.description.toLowerCase().includes(searchLower);
          }
          
          return false;
        });
      }
      
      // Log for debugging
      console.log(`Search term: "${searchLower}"`);
      console.log(`Filtered items:`, filteredData.map(item => item.title));
    }
    
    // Apply category filter
    if (filters.category) {
      filteredData = filteredData.filter(item => 
        item.category.toLowerCase() === filters.category!.toLowerCase()
      );
    }
    
    // Apply condition filter
    if (filters.condition) {
      filteredData = filteredData.filter(item => 
        item.condition === filters.condition
      );
    }

    if (filters.neighborhood) {
      filteredData = filteredData.filter(item => item.neighborhood === filters.neighborhood);
    }
    
    // Apply price filters
    if (filters.minPrice !== undefined) {
      filteredData = filteredData.filter(item => item.price >= filters.minPrice!);
    }
    if (filters.maxPrice !== undefined) {
      filteredData = filteredData.filter(item => item.price <= filters.maxPrice!);
    }
    
    // Apply sorting
    if (filters.sortBy) {
      const sortOrder = filters.sortOrder === 'asc' ? 1 : -1;
      filteredData.sort((a, b) => {
        if (filters.sortBy === 'price') {
          return (a.price - b.price) * sortOrder;
        } else if (filters.sortBy === 'createdAt') {
          // In mock data, just sort by ID for now
          return (a._id.localeCompare(b._id)) * sortOrder;
        }
        return 0;
      });
    }
    
    // Apply pagination
    const page = filters.page || 1;
    const limit = filters.limit || 10;
    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    const paginatedData = filteredData.slice(startIndex, endIndex);
    
    return {
      furniture: paginatedData,
      totalPages: Math.ceil(filteredData.length / limit)
    };
  }

  async createFurniture(data: NewFurnitureData) {
    try {
      if (this.useMockData) {
        // 在模拟模式下，添加到MOCK_FURNITURE数组和卖家列表
        const furnitureWithSeller: FurnitureData = {
          ...data,
          _id: Date.now().toString(),
          sellerId: 'current-seller',
        }; // 标记为当前卖家的物品
        MOCK_FURNITURE.unshift(furnitureWithSeller); // 添加到数组开头，这样它会显示在最近添加的列表中
        
        // 同时添加到卖家专用列表
        if (!this.sellerListings) {
          this.sellerListings = [];
        }
        this.sellerListings.unshift(furnitureWithSeller);
        
        // Save to localStorage
        this.saveSellerListings();
        
        return { furniture: furnitureWithSeller };
      }
      
      const response = await axios.post(`${API_URL}/furniture`, data, {
        headers: this.getAuthHeader(),
      });
      // Backend returns the furniture object directly; normalize to { furniture }
      return { furniture: response.data };
    } catch (error) {
      console.error('Error creating furniture:', error);
      throw error;
    }
  }

  async getFurniture(filters: FurnitureFilters = {}) {
    try {
      if (this.useMockData) {
        return this.filterMockData(filters);
      }

      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined) {
          params.append(key, value.toString());
        }
      });

      if (filters.search) {
        return this.searchFurniture(filters.search, filters.page, filters.limit);
      }

      const response = await axios.get(`${API_URL}/furniture?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching furniture:', error);
      if (this.useMockData) {
        return this.filterMockData(filters);
      }
      throw error;
    }
  }

  // Seller WeChat ID; the API only answers signed-in, .edu-verified students.
  async getSellerContact(id: string): Promise<string> {
    const response = await axios.get(`${API_URL}/furniture/${id}/contact`, {
      headers: this.getAuthHeader(),
    });
    return response.data?.wechatId || '';
  }

  async getFurnitureById(id: string) {
    try {
      if (this.useMockData) {
        // First search in MOCK_FURNITURE
        let item = MOCK_FURNITURE.find(furniture => furniture._id === id);
        
        // If not found in MOCK_FURNITURE, search in seller listings
        if (!item && this.sellerListings) {
          item = this.sellerListings.find(furniture => furniture._id === id);
        }
        
        if (item) {
          console.log('Found furniture by ID:', id, item);
          return { furniture: item };
        }
        console.error('Furniture not found with ID:', id);
        throw new Error('Furniture not found');
      }

      const response = await axios.get(`${API_URL}/furniture/${id}`);
      // Backend returns the furniture object directly; normalize to { furniture }
      return { furniture: response.data };
    } catch (error) {
      console.error(`Error fetching furniture with ID ${id}:`, error);
      if (this.useMockData) {
        // Fallback search in both arrays
        let item = MOCK_FURNITURE.find(furniture => furniture._id === id);
        if (!item && this.sellerListings) {
          item = this.sellerListings.find(furniture => furniture._id === id);
        }
        if (item) {
          return { furniture: item };
        }
      }
      throw error;
    }
  }

  async updateFurniture(id: string, data: Partial<FurnitureData>) {
    try {
      if (this.useMockData) {
        // Update in MOCK_FURNITURE array
        const mockIndex = MOCK_FURNITURE.findIndex(item => item._id === id);
        if (mockIndex !== -1) {
          MOCK_FURNITURE[mockIndex] = { ...MOCK_FURNITURE[mockIndex], ...data };
        }
        
        // Update in seller listings
        const sellerIndex = this.sellerListings.findIndex(item => item._id === id);
        if (sellerIndex !== -1) {
          this.sellerListings[sellerIndex] = { ...this.sellerListings[sellerIndex], ...data };
          this.saveSellerListings();
        }
        
        return { furniture: MOCK_FURNITURE[mockIndex] };
      }
      
      const response = await axios.put(`${API_URL}/furniture/${id}`, data, {
        headers: this.getAuthHeader(),
      });
      // Backend returns the furniture object directly; normalize to { furniture }
      return { furniture: response.data };
    } catch (error) {
      console.error(`Error updating furniture with ID ${id}:`, error);
      throw error;
    }
  }

  async deleteFurniture(id: string) {
    try {
      if (this.useMockData) {
        // Remove from MOCK_FURNITURE array
        const mockIndex = MOCK_FURNITURE.findIndex(item => item._id === id);
        if (mockIndex !== -1) {
          MOCK_FURNITURE.splice(mockIndex, 1);
        }
        
        // Remove from seller listings
        const sellerIndex = this.sellerListings.findIndex(item => item._id === id);
        if (sellerIndex !== -1) {
          this.sellerListings.splice(sellerIndex, 1);
          this.saveSellerListings();
        }
        
        return { message: 'Furniture deleted successfully' };
      }
      
      const response = await axios.delete(`${API_URL}/furniture/${id}`, {
        headers: this.getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      console.error(`Error deleting furniture with ID ${id}:`, error);
      throw error;
    }
  }

  async searchFurniture(query: string, page = 1, limit = 10) {
    try {
      if (this.useMockData) {
        return this.filterMockData({ search: query, page, limit });
      }

      const response = await axios.get(
        `${API_URL}/furniture/search?q=${encodeURIComponent(query)}&page=${page}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      console.error(`Error searching furniture with query "${query}":`, error);
      if (this.useMockData) {
        return this.filterMockData({ search: query, page, limit });
      }
      throw error;
    }
  }

  async getSellerListings(status?: string, page = 1, limit = 10) {
    try {
      if (this.useMockData) {
        // Return seller's specific listings in mock mode
        const startIndex = (page - 1) * limit;
        const endIndex = startIndex + limit;
        const paginatedListings = this.sellerListings.slice(startIndex, endIndex);
        
        return {
          furniture: paginatedListings,
          totalPages: Math.ceil(this.sellerListings.length / limit)
        };
      }

      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      });
      if (status) {
        params.append('status', status);
      }

      const response = await axios.get(
        `${API_URL}/furniture/seller/listings?${params.toString()}`,
        {
          headers: this.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching seller listings:', error);
      if (this.useMockData) {
        return this.filterMockData({ status, page, limit });
      }
      throw error;
    }
  }
}

export const furnitureService = new FurnitureService();
